<template>
  <div>

    <navbar></navbar>

    <div class="bg-header-round-small">
      <div class="container">
        <h1>Zahlungsarten</h1>
      </div>
    </div>

    <section class="container">
      <h2>Wir akzeptieren folgende Zahlungsarten</h2>
      <h3 class="mb-3" >Kreditkarten</h3>
      <div class="text-center" >
        <img src="@assets/icons/icon-MasterCard.png">
        <img src="@assets/icons/icon-American_Express.png">
        <img src="@assets/icons/icon-Visa.png">
      </div>

      <p class="mt-4 mb-2">
        Die Zahlarten können im Rahmen einer Bonitätsprüfung eingeschränkt werden. Sie können mindestens mit Kreditkarte. Die Zahlungsabwicklung übernimmt der Bezahlprovider Stripe.
      </p>
      <p class="mb-2">
        Zur Zeit können noch keine anderen Zahlungsmöglichkeiten angeboten werden, weil bei 24/7-Bestellungen sich der Abrechnungsbetrag verringern kann (wenn z.B.: der Händler das gewünschte Produkt nicht mehr liefern kann, oder sich Liefermengen verringern).
      </p>
    </section>

    <cgfooter></cgfooter>

  </div>
</template>

<script>
  import Navbar from '@/components/Navbar.vue'
  import CgFooter from '@/components/CgFooter.vue'

  export default {
    name: 'servicePayment',
    components: {
      'navbar': Navbar,
      'cgfooter': CgFooter
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/service/Payment.vue